import Utils from "@/utils/utils"

export const TIME_BETWEEN_START_AND_END = Utils.minutes(30)
